import { useContext } from 'react'

import Context from './CatalogConfigurationContext'

const useCatalogConfigurationContext = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error(
      'useCatalogConfigurationContext must be used within a CatalogConfigurationProvider',
    )
  }

  return context
}

export default useCatalogConfigurationContext
